/* eslint-disable no-undef */
/* eslint-disable no-restricted-globals */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { 
  Users, 
  TrendingUp, 
  DollarSign, 
  Calendar, 
  Search, 
  Filter, 
  Plus, 
  Eye,
  Check,
  X,
  Clock,
  AlertTriangle,
  ChevronRight,
  Download,
  RefreshCw,
  Settings,
  User,
  Shield,
  LogOut,
  Upload,
  FileText,
  BarChart3,
  PieChart,
  CheckSquare,
  Square,
  ChevronDown,
  ChevronUp,
  ArrowUpDown,
  Trash2,
  Edit3,
  Copy,
  ExternalLink,
  Bell,
  Wifi,
  WifiOff
} from 'lucide-react';

import { KileleniService } from '../components/kileleni/services/kileleniService';

const KileleniManagement = () => {
 
  const [userInfo, setUserInfo] = useState(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  
  // Component state
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [verificationFilter, setVerificationFilter] = useState('pending');
  const [accountTypeFilter, setAccountTypeFilter] = useState('all');
  
  // Data states
  const [dashboardData, setDashboardData] = useState(null);
  const [groups, setGroups] = useState([]);
  const [verificationRequests, setVerificationRequests] = useState([]);
  const [transactionAccounts, setTransactionAccounts] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedVerification, setSelectedVerification] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [showAccountForm, setShowAccountForm] = useState(false);
  const [showDeleteGroupModal, setShowDeleteGroupModal] = useState(null);
  const [showBulkActions, setShowBulkActions] = useState(false);
  // Daraja states
  const [darajas, setDarajas] = useState([]);
  const [selectedDaraja, setSelectedDaraja] = useState(null);
  const [showDarajaForm, setShowDarajaForm] = useState(false);
  // Enhanced UI state
  const [selectedItems, setSelectedItems] = useState(new Set());
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [viewMode, setViewMode] = useState('table'); // table, grid, list
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [notifications, setNotifications] = useState([]);
  
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(20);
 
  // Connection monitoring
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Auto-clear notifications
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(null), 8000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  // Enhanced authentication check
  // useEffect(() => {
  //   initializeAuth();
  // }, []);

  // const initializeAuth = async () => {
  //   try {
  //     setIsCheckingAuth(true);
      
  //     const token = localStorage.getItem('token') || 
  //                  localStorage.getItem('authToken') || 
  //                  sessionStorage.getItem('authToken');
      
  //     if (!token) {
  //       console.warn('No authentication token found');
  //       setIsAuthenticated(false);
  //       return;
  //     }

  //     KileleniService.init(token);
  //     const testResult = await KileleniService.testConnection();
      
  //     if (!testResult.success) {
  //       throw new Error(testResult.error || 'Connection test failed');
  //     }

  //     try {
  //       const userData = await KileleniService.getAdminDashboard();
  //       setIsAuthenticated(true);
  //       setUserInfo(userData.user_info);
  //       console.log('✅ Admin authentication successful');
  //     } catch (adminError) {
  //       if (adminError.status === 403) {
  //         throw new Error('You do not have admin permissions');
  //       } else if (adminError.status === 401) {
  //         throw new Error('Authentication expired. Please log in again.');
  //       } else {
  //         throw adminError;
  //       }
  //     }

  //   } catch (error) {
  //     console.error('❌ Authentication failed:', error);
  //     setError(error.message);
  //     setIsAuthenticated(false);
      
  //     // KileleniService.logout();
      
  //     setTimeout(() => {
  //       // window.location.href = '/login';
  //     }, 3000);
      
  //   } finally {
  //     setIsCheckingAuth(false);
  //   }
  // };

  // Enhanced data loading with caching
  const loadDashboardData = useCallback(async () => {
    // if (!isAuthenticated) return;
    
    setLoading(true);
    setError(null);
    
    try {
      console.log('🔄 Loading admin dashboard...');
      const data = await KileleniService.getAdminDashboard();
      setDashboardData(data);
      console.log('✅ Dashboard loaded successfully');
    } catch (err) {
      console.error('❌ Dashboard load failed:', err);
      const errorMessage = KileleniService.getErrorMessage(err);
      setError(errorMessage);
     
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
     loadDashboardData();
  }, [loadDashboardData]);

  // Enhanced tab data loading with debouncing
  useEffect(() => {
   

    const timeoutId = setTimeout(() => {
      loadTabData();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [activeTab, currentPage, statusFilter, verificationFilter, accountTypeFilter, searchTerm, pageSize]);

  const loadTabData = async () => {
    try {
      switch (activeTab) {
        case 'groups':
          await loadGroups();
          break;
        case 'verifications':
          await loadVerificationRequests();
          break;
        case 'accounts':
          await loadTransactionAccounts();
          break;
        case 'darajas': 
          await loadDarajas();
          break;
        default:
          break;
      }
    } catch (error) {
      console.error(`Error loading ${activeTab} data:`, error);
      setError(KileleniService.getErrorMessage(error));
    }
  };

  const loadGroups = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        page_size: pageSize,
        ...(statusFilter !== 'all' && { status: statusFilter }),
        ...(verificationFilter !== 'all' && { verification_status: verificationFilter }),
        ...(searchTerm && { search: searchTerm })
      };
      
      const response = await KileleniService.getAdminGroups(params);
      setGroups(response.results || response);
      
      if (response.count) {
        setTotalPages(Math.ceil(response.count / pageSize));
      }
    } catch (err) {
      console.error('Error loading groups:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  
// FIXED: Enhanced verification request loading
const loadVerificationRequests = async () => {
  setLoading(true);
  try {
    console.log('🔄 Loading verification requests...');
    console.log('Current filter:', verificationFilter);
    console.log('Current page:', currentPage);
    
    const params = {
      page: currentPage,
      page_size: pageSize,
      // REMOVED the problematic status filter that was excluding requests
      ...(verificationFilter !== 'all' && verificationFilter !== 'pending_verification' && { status: verificationFilter })
    };
    
    // Add specific handling for pending verification filter
    if (verificationFilter === 'pending_verification') {
      params.status = 'pending';
    }
    
    console.log('Request params:', params);
    
    const response = await KileleniService.getVerificationRequests(params);
    console.log('✅ Verification requests response:', response);
    
    const results = response.results || response;
    console.log(`📊 Found ${results.length} verification requests`);
    
    // Log details of each request
    results.forEach((req, index) => {
      console.log(`Request ${index + 1}:`, {
        id: req.id,
        group: req.group_name,
        lap: req.lap_number || 1,
        status: req.status,
        is_subsequent: req.is_subsequent_lap || false,
        created: req.created_at
      });
    });
    
    setVerificationRequests(results);
    
    if (response.count) {
      setTotalPages(Math.ceil(response.count / pageSize));
    }
  } catch (err) {
    console.error('❌ Error loading verification requests:', err);
    setError(KileleniService.getErrorMessage(err));
  } finally {
    setLoading(false);
  }
};
  const loadTransactionAccounts = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        page_size: pageSize,
        ...(accountTypeFilter !== 'all' && { type: accountTypeFilter }),
        ...(searchTerm && { search: searchTerm })
      };
      
      const response = await KileleniService.getTransactionAccounts(params);
      setTransactionAccounts(response.results || response);
      
      if (response.count) {
        setTotalPages(Math.ceil(response.count / pageSize));
      }
    } catch (err) {
      console.error('Error loading transaction accounts:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };
// Load Darajas ============================================================

  const loadDarajas = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        page_size: pageSize,
        ...(searchTerm && { search: searchTerm }),
        ...(statusFilter !== 'all' && { is_active: statusFilter === 'active' })
      };
      
      const response = await KileleniService.getDarajaLevels(params);
      setDarajas(response.results || response);
      
      if (response.count) {
        setTotalPages(Math.ceil(response.count / pageSize));
      }
    } catch (err) {
      console.error('Error loading darajas:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };
  // Enhanced action handlers with optimistic updates
  const handleVerificationAction = async (verificationId, action, amounts = {}) => {
    setLoading(true);
    try {
      const actionData = {
        action,
        ...amounts
      };
      
      await KileleniService.processVerificationRequest(verificationId, actionData);
      
      setSuccess(`Verification ${action} successful`);
      
      // Optimistic update
      setVerificationRequests(prev => 
        prev.map(req => 
          req.id === verificationId 
            ? { ...req, status: action === 'approve' ? 'approved' : action }
            : req
        )
      );
      
      await Promise.all([
        loadDashboardData(),
        loadVerificationRequests()
      ]);
      
      setSelectedVerification(null);
    } catch (err) {
      console.error(`❌ Verification ${action} failed:`, err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleGroupView = async (groupId) => {
    setLoading(true);
    try {
      const [group, members] = await Promise.all([
        KileleniService.getGroup(groupId),
        KileleniService.getGroupMembers(groupId)
      ]);
      
      setSelectedGroup({ ...group, members });
    } catch (err) {
      console.error('Error loading group details:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleCreateAccount = async (accountData) => {
    setLoading(true);
    try {
      const newAccount = await KileleniService.createTransactionAccount(accountData);
      
      setSuccess('Transaction account created successfully');
      
      // Optimistic update
      setTransactionAccounts(prev => [newAccount, ...prev]);
      
      await loadTransactionAccounts();
      setShowAccountForm(false);
      setSelectedAccount(null);
    } catch (err) {
      console.error('❌ Account creation failed:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateAccount = async (accountId, accountData) => {
    setLoading(true);
    try {
      const updatedAccount = await KileleniService.updateTransactionAccount(accountId, accountData);
      
      setSuccess('Transaction account updated successfully');
      
      // Optimistic update
      setTransactionAccounts(prev => 
        prev.map(acc => acc.id === accountId ? updatedAccount : acc)
      );
      
      await loadTransactionAccounts();
      setShowAccountForm(false);
      setSelectedAccount(null);
    } catch (err) {
      console.error('❌ Account update failed:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAccount = async (accountId) => {
    if (!confirm('Are you sure you want to delete this transaction account? This action cannot be undone.')) {
      return;
    }

    setLoading(true);
    try {
      await KileleniService.deleteTransactionAccount(accountId);
      
      setSuccess('Transaction account deleted successfully');
      
      // Optimistic update
      setTransactionAccounts(prev => prev.filter(acc => acc.id !== accountId));
      
      await loadTransactionAccounts();
    } catch (err) {
      console.error('❌ Account deletion failed:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteGroup = async (groupId) => {
    setLoading(true);
    try {
      await KileleniService.deleteGroup(groupId);
      
      setSuccess('Group deleted successfully');
      
      // Optimistic update
      setGroups(prev => prev.filter(group => group.id !== groupId));
      
      await Promise.all([
        loadDashboardData(),
        loadGroups()
      ]);
      
      setShowDeleteGroupModal(null);
    } catch (err) {
      console.error('❌ Group deletion failed:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };
// handleCreateDaraja ============================================================

  const handleCreateDaraja = async (darajaData) => {
    setLoading(true);
    try {
      const newDaraja = await KileleniService.createDarajaLevel(darajaData);
      
      setSuccess('Daraja level created successfully');
      
      // Optimistic update
      setDarajas(prev => [newDaraja, ...prev]);
      
      await loadDarajas();
      setShowDarajaForm(false);
      setSelectedDaraja(null);
    } catch (err) {
      console.error('❌ Daraja creation failed:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };


  const handleUpdateDaraja = async (darajaId, darajaData) => {
    setLoading(true);
    try {
      const updatedDaraja = await KileleniService.updateDarajaLevel(darajaId, darajaData);
      
      setSuccess('Daraja level updated successfully');
      
      // Optimistic update
      setDarajas(prev => 
        prev.map(daraja => daraja.id === darajaId ? updatedDaraja : daraja)
      );
      
      await loadDarajas();
      setShowDarajaForm(false);
      setSelectedDaraja(null);
    } catch (err) {
      console.error('❌ Daraja update failed:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteDaraja = async (darajaId) => {
    if (!confirm('Are you sure you want to delete this Daraja level? This action cannot be undone.')) {
      return;
    }

    setLoading(true);
    try {
      await KileleniService.deleteDarajaLevel(darajaId);
      
      setSuccess('Daraja level deleted successfully');
      
      // Optimistic update
      setDarajas(prev => prev.filter(daraja => daraja.id !== darajaId));
      
      await loadDarajas();
    } catch (err) {
      console.error('❌ Daraja deletion failed:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };
  // Bulk operations
  const handleSelectAll = (items) => {
    if (selectedItems.size === items.length) {
      setSelectedItems(new Set());
    } else {
      setSelectedItems(new Set(items.map(item => item.id)));
    }
  };

  const handleSelectItem = (itemId) => {
    const newSelected = new Set(selectedItems);
    if (newSelected.has(itemId)) {
      newSelected.delete(itemId);
    } else {
      newSelected.add(itemId);
    }
    setSelectedItems(newSelected);
  };

  const handleBulkDelete = async (itemType) => {
    if (selectedItems.size === 0) return;
    
    const confirmMessage = `Are you sure you want to delete ${selectedItems.size} ${itemType}(s)? This action cannot be undone.`;
    if (!confirm(confirmMessage)) return;

    setLoading(true);
    try {
      const deletePromises = Array.from(selectedItems).map(id => {
        switch (itemType) {
          case 'group':
            return KileleniService.deleteGroup(id);
          case 'account':
            return KileleniService.deleteTransactionAccount(id);
          case 'daraja': 
            return KileleniService.deleteDarajaLevel(id);
          default:
            return Promise.resolve();
        }
      });

      await Promise.all(deletePromises);
      
      setSuccess(`Successfully deleted ${selectedItems.size} ${itemType}(s)`);
      setSelectedItems(new Set());
      
      // Reload data
      await loadTabData();
      await loadDashboardData();
      
    } catch (err) {
      console.error('❌ Bulk delete failed:', err);
      setError(KileleniService.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  // Export functionality
  const handleExportData = async (dataType) => {
    try {
      setLoading(true);
      let data, filename;
      
      switch (dataType) {
        case 'groups':
          data = await KileleniService.exportGroups();
          filename = `groups_export_${new Date().toISOString().split('T')[0]}.csv`;
          break;
        case 'accounts':
          data = await KileleniService.exportTransactionAccounts();
          filename = `accounts_export_${new Date().toISOString().split('T')[0]}.csv`;
          break;
        case 'verifications':
          data = await KileleniService.exportVerificationRequests();
          filename = `verifications_export_${new Date().toISOString().split('T')[0]}.csv`;
          break;
        case 'darajas': 
          data = await KileleniService.exportDarajaLevels();
          filename = `darajas_export_${new Date().toISOString().split('T')[0]}.csv`;
          break;
        default:
          throw new Error('Invalid export type');
      }

      // Create and download file
      const blob = new Blob([data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
      setSuccess(`${dataType} data exported successfully`);
    } catch (err) {
      console.error('Export failed:', err);
      setError('Failed to export data');
    } finally {
      setLoading(false);
    }
  };

  // Sorting
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedData = useMemo(() => {
    let currentData = [];
    
    switch (activeTab) {
      case 'groups':
        currentData = groups;
        break;
      case 'verifications':
        currentData = verificationRequests;
        break;
      case 'accounts':
        currentData = transactionAccounts;
        break;
      case 'darajas':
        currentData = darajas;
        break;
      default:
        return [];
    }

    if (!sortConfig.key) return currentData;

    return [...currentData].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];
      
      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [groups, verificationRequests, transactionAccounts, darajas, sortConfig, activeTab]);

  const formatCurrency = (amount) => {
    return KileleniService.formatCurrency(amount);
  };

  const getStatusBadge = (status) => {
    const colors = KileleniService.getStatusBadgeClass(status);
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${colors}`}>
        {status}
      </span>
    );
  };

 
  // if (!isAuthenticated) {
  //   return <AuthenticationError error={error} />;
  // }

  if (loading && !dashboardData) {
    return <LoadingScreen message="Loading admin dashboard..." />;
  }

  return (
    <div className="min-h-screen bg-gray-50" style={{ backgroundColor: '#f8fafc' }}>
      {/* Enhanced Header */}
      <div className="text-white p-6" style={{ backgroundColor: '#001f3f' }}>
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold mb-2 flex items-center gap-3">
                <Shield className="h-8 w-8" />
                Super Admin Dashboard
                {!isOnline && <WifiOff className="h-6 w-6 text-red-400" />}
                {isOnline && <Wifi className="h-6 w-6 text-green-400" />}
              </h1>
              <p className="text-blue-100">Kileleni Management System - Administrative Control Panel</p>
              {userInfo && (
                <p className="text-blue-200 text-sm mt-1">
                  Welcome back, {userInfo.name || userInfo.email}
                </p>
              )}
            </div>
            <div className="flex items-center gap-4">
              <button
                onClick={loadDashboardData}
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
                disabled={loading}
              >
                <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
                Refresh
              </button>
              
              {/* Export Dropdown */}
              <div className="relative">
                <button className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg transition-colors">
                  <Download className="h-4 w-4" />
                  Export
                </button>
              </div>
              
              {/* Notifications */}
              {notifications.length > 0 && (
                <button className="relative p-2 bg-yellow-600 hover:bg-yellow-700 rounded-lg">
                  <Bell className="h-4 w-4" />
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                    {notifications.length}
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Success/Error Messages */}
      <NotificationBar success={success} error={error} />

      {/* Enhanced Navigation Tabs */}
      <div className="bg-white shadow-sm">
        <div className="max-w-8xl mx-auto px-6">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', label: 'Overview', icon: TrendingUp, count: null },
              { id: 'groups', label: 'Groups', icon: Users, count: dashboardData?.total_groups },
              { id: 'verifications', label: 'Verification Requests', icon: Shield, count: dashboardData?.pending_verifications },
              { id: 'accounts', label: 'Transaction Accounts', icon: DollarSign, count: null },
              { id: 'darajas', label: 'Daraja Levels', icon: BarChart3, count: null }, 
            ].map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => {
                    setActiveTab(tab.id);
                    setCurrentPage(1);
                    setError(null);
                    setSelectedItems(new Set());
                  }}
                  className={`flex items-center gap-2 px-3 py-4 border-b-2 font-medium text-sm transition-colors relative ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon className="h-4 w-4" />
                  {tab.label}
                  {tab.count !== null && tab.count > 0 && (
                    <span className="ml-1 bg-red-500 text-white text-xs rounded-full px-2 py-0.5">
                      {tab.count}
                    </span>
                  )}
                </button>
              );
            })}
          </nav>
        </div>
      </div>

      <div className="max-w-8xl mx-auto px-6 py-6">
        {/* Overview Tab */}
        {activeTab === 'overview' && dashboardData && (
          <OverviewTab 
            dashboardData={dashboardData} 
            formatCurrency={formatCurrency}
            getStatusBadge={getStatusBadge}
            onNavigateToTab={setActiveTab}
            onSelectGroup={setSelectedGroup}
            onSelectVerification={setSelectedVerification}
          />
        )}

        {/* Enhanced Groups Tab */}
        {activeTab === 'groups' && (
          <EnhancedDataTab
            title="Groups Management"
            data={sortedData}
            columns={groupColumns}
            loading={loading}
            selectedItems={selectedItems}
            onSelectAll={() => handleSelectAll(sortedData)}
            onSelectItem={handleSelectItem}
            onSort={handleSort}
            sortConfig={sortConfig}
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            filters={[
              {
                label: 'Status',
                value: statusFilter,
                onChange: setStatusFilter,
                options: [
                  { value: 'all', label: 'All Status' },
                  { value: 'pending', label: 'Pending' },
                  { value: 'active', label: 'Active' },
                  { value: 'verified', label: 'Verified' },
                  { value: 'completed', label: 'Completed' }
                ]
              },
              {
                label: 'Verification',
                value: verificationFilter,
                onChange: setVerificationFilter,
                options: [
                  { value: 'all', label: 'All Verification' },
                  { value: 'verified', label: 'Verified' },
                  { value: 'pending_verification', label: 'Pending' },
                  { value: 'not_verified', label: 'Not Verified' }
                ]
              }
            ]}
            actions={[
              {
                label: 'View Details',
                icon: Eye,
                onClick: (group) => handleGroupView(group.id),
                variant: 'primary'
              },
              {
                label: 'Delete',
                icon: Trash2,
                onClick: (group) => setShowDeleteGroupModal(group),
                variant: 'danger'
              }
            ]}
            bulkActions={[
              {
                label: 'Delete Selected',
                icon: Trash2,
                onClick: () => handleBulkDelete('group'),
                variant: 'danger'
              }
            ]}
            onExport={() => handleExportData('groups')}
            formatters={{
              currency: formatCurrency,
              status: getStatusBadge,
              date: (date) => KileleniService.formatDate(date)
            }}
          />
        )}

        {/* Enhanced Verification Requests Tab */}
        {activeTab === 'verifications' && (
          <EnhancedDataTab
            title="Verification Requests"
            data={sortedData}
            columns={verificationColumns}
            loading={loading}
            selectedItems={selectedItems}
            onSelectAll={() => handleSelectAll(sortedData)}
            onSelectItem={handleSelectItem}
            onSort={handleSort}
            sortConfig={sortConfig}
            verificationFilter={verificationFilter}
            filters={[
              {
                label: 'Status',
                value: verificationFilter,
                onChange: setVerificationFilter,
                options: [
                  { value: 'all', label: 'All Requests' },
                  { value: 'pending', label: 'Pending' },
                  { value: 'approved', label: 'Approved' },
                  { value: 'rejected', label: 'Rejected' },
                  { value: 'needs_info', label: 'Needs Info' }
                ]
              }
            ]}
            actions={[
              {
                label: 'Process',
                icon: Settings,
                onClick: (verification) => setSelectedVerification(verification),
                variant: 'primary'
              }
            ]}
            onExport={() => handleExportData('verifications')}
            formatters={{
              currency: formatCurrency,
              status: getStatusBadge,
              date: (date) => KileleniService.formatDate(date)
            }}
          />
        )}

        {/* Enhanced Transaction Accounts Tab */}
        {activeTab === 'accounts' && (
          <EnhancedDataTab
            title="Transaction Accounts"
            data={sortedData}
            columns={accountColumns}
            loading={loading}
            selectedItems={selectedItems}
            onSelectAll={() => handleSelectAll(sortedData)}
            onSelectItem={handleSelectItem}
            onSort={handleSort}
            sortConfig={sortConfig}
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            filters={[
              {
                label: 'Type',
                value: accountTypeFilter,
                onChange: setAccountTypeFilter,
                options: [
                  { value: 'all', label: 'All Types' },
                  { value: 'special', label: 'Special' },
                  { value: 'regular', label: 'Regular' }
                ]
              }
            ]}
            actions={[
              {
                label: 'Edit',
                icon: Edit3,
                onClick: (account) => {
                  setSelectedAccount(account);
                  setShowAccountForm(true);
                },
                variant: 'primary'
              },
              {
                label: 'Delete',
                icon: Trash2,
                onClick: (account) => handleDeleteAccount(account.id),
                variant: 'danger'
              }
            ]}
            bulkActions={[
              {
                label: 'Delete Selected',
                icon: Trash2,
                onClick: () => handleBulkDelete('account'),
                variant: 'danger'
              }
            ]}
            createAction={{
              label: 'Create Account',
              icon: Plus,
              onClick: () => {
                setSelectedAccount(null);
                setShowAccountForm(true);
              }
            }}
            onExport={() => handleExportData('accounts')}
            formatters={{
              currency: formatCurrency,
              status: getStatusBadge,
              date: (date) => KileleniService.formatDate(date)
            }}
          />
        )}
         {activeTab === 'darajas' && (
          <EnhancedDataTab
            title="Daraja Levels Management"
            data={sortedData}
            columns={darajaColumns}
            loading={loading}
            selectedItems={selectedItems}
            onSelectAll={() => handleSelectAll(sortedData)}
            onSelectItem={handleSelectItem}
            onSort={handleSort}
            sortConfig={sortConfig}
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            filters={[
              {
                label: 'Status',
                value: statusFilter,
                onChange: setStatusFilter,
                options: [
                  { value: 'all', label: 'All Status' },
                  { value: 'active', label: 'Active Only' },
                  { value: 'inactive', label: 'Inactive Only' }
                ]
              }
            ]}
            actions={[
              {
                label: 'Edit',
                icon: Edit3,
                onClick: (daraja) => {
                  setSelectedDaraja(daraja);
                  setShowDarajaForm(true);
                },
                variant: 'primary'
              },
              {
                label: 'Delete',
                icon: Trash2,
                onClick: (daraja) => handleDeleteDaraja(daraja.id),
                variant: 'danger'
              }
            ]}
            bulkActions={[
              {
                label: 'Delete Selected',
                icon: Trash2,
                onClick: () => handleBulkDelete('daraja'),
                variant: 'danger'
              }
            ]}
            createAction={{
              label: 'Create Daraja Level',
              icon: Plus,
              onClick: () => {
                setSelectedDaraja(null);
                setShowDarajaForm(true);
              }
            }}
            onExport={() => handleExportData('darajas')}
            formatters={{
              currency: formatCurrency,
              status: getStatusBadge,
              date: (date) => KileleniService.formatDate(date)
            }}
          />
        )}

        {/* Enhanced Pagination */}
        <EnhancedPagination
          currentPage={currentPage}
          totalPages={totalPages}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={setPageSize}
          loading={loading}
        />
      </div>

      {/* Modals */}
      <ModalsContainer
        selectedVerification={selectedVerification}
        onCloseVerification={() => setSelectedVerification(null)}
        onVerificationAction={handleVerificationAction}
        selectedGroup={selectedGroup}
        onCloseGroup={() => setSelectedGroup(null)}
        selectedAccount={selectedAccount}
        showAccountForm={showAccountForm}
        selectedDaraja={selectedDaraja}
  showDarajaForm={showDarajaForm}
  onCloseDarajaForm={() => {
    setShowDarajaForm(false);
    setSelectedDaraja(null);
  }}
  onSaveDaraja={selectedDaraja ? 
    (data) => handleUpdateDaraja(selectedDaraja.id, data) : 
    handleCreateDaraja
  }
        onCloseAccountForm={() => {
          setShowAccountForm(false);
          setSelectedAccount(null);
        }}
        onSaveAccount={selectedAccount ? 
          (data) => handleUpdateAccount(selectedAccount.id, data) : 
          handleCreateAccount
        }
        showDeleteGroupModal={showDeleteGroupModal}
        onCloseDeleteGroup={() => setShowDeleteGroupModal(null)}
        onConfirmDeleteGroup={() => handleDeleteGroup(showDeleteGroupModal.id)}
        formatCurrency={formatCurrency}
        getStatusBadge={getStatusBadge}
      />

      {/* Loading Overlay */}
      {loading && <LoadingOverlay />}
    </div>
  );
};

// Column definitions
const groupColumns = [
  { key: 'name', label: 'Group Name', sortable: true },
  { key: 'chairperson_name', label: 'Chairperson', sortable: true },
  { key: 'daraja_name', label: 'Daraja', sortable: true },
  { key: 'member_count', label: 'Members', sortable: true, align: 'center' },
  { key: 'status', label: 'Status', sortable: true, align: 'center', type: 'status' },
  { key: 'verification_status', label: 'Verification', sortable: true, align: 'center', type: 'status' },
  { key: 'created_at', label: 'Created', sortable: true, align: 'center', type: 'date' },
];

const verificationColumns = [
  { key: 'group_name', label: 'Group Name', sortable: true },
  { key: 'requested_by_name', label: 'Chairperson', sortable: true },
  { key: 'group_daraja', label: 'Daraja', sortable: true },
  { key: 'group_member_count', label: 'Members', sortable: true, align: 'center' },
  { key: 'proposed_seb_amount', label: 'Proposed SEB', sortable: true, align: 'right', type: 'currency' },
  { key: 'proposed_pei_amount', label: 'Proposed PEI', sortable: true, align: 'right', type: 'currency' },
  { key: 'status', label: 'Status', sortable: true, align: 'center', type: 'status' },
  { key: 'days_pending', label: 'Days Pending', sortable: true, align: 'center' },
];

const accountColumns = [
  { key: 'name', label: 'Account Name', sortable: true },
  { key: 'account_number', label: 'Account Number', sortable: true },
  { key: 'account_type_display', label: 'Type', sortable: true },
  { key: 'is_special', label: 'Category', sortable: true, align: 'center', type: 'special' },
  { key: 'min_balance', label: 'Min Balance', sortable: true, align: 'right', type: 'currency' },
  { key: 'is_active', label: 'Status', sortable: true, align: 'center', type: 'active' },
];
//darajaColumns ============================================================

const darajaColumns = [
  { key: 'name', label: 'Daraja Name', sortable: true },
  { key: 'min_amount', label: 'Min Amount', sortable: true, align: 'right', type: 'currency' },
  { key: 'max_amount', label: 'Max Amount', sortable: true, align: 'right', type: 'currency' },
  { key: 'total_base_amount', label: 'Total Base', sortable: true, align: 'right', type: 'currency' },
  { key: 'enf_amount', label: 'ENF', sortable: true, align: 'right', type: 'currency' },
  { key: 'escrow_amount', label: 'Escrow', sortable: true, align: 'right', type: 'currency' },
  { key: 'is_active', label: 'Status', sortable: true, align: 'center', type: 'active' },
  { key: 'created_at', label: 'Created', sortable: true, align: 'center', type: 'date' },
];



// Enhanced Components
const LoadingScreen = ({ message }) => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
      <p className="text-gray-600">{message}</p>
    </div>
  </div>
);


const NotificationBar = ({ success, error }) => {
  if (!success && !error) return null;

  return (
    <div className="max-w-7xl mx-auto px-6 py-2">
      {success && (
        <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-4">
          <div className="flex items-center">
            <Check className="h-5 w-5 text-green-400 mr-2" />
            <span className="text-green-800">{success}</span>
          </div>
        </div>
      )}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <AlertTriangle className="h-5 w-5 text-red-400 mr-2" />
              <span className="text-red-800">{error}</span>
            </div>
            <button className="text-red-400 hover:text-red-600">
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const LoadingOverlay = () => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 flex items-center gap-3">
      <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
      <span className="text-gray-700">Processing...</span>
    </div>
  </div>
);

// Enhanced Overview Tab Component
const OverviewTab = ({ dashboardData, formatCurrency, getStatusBadge, onNavigateToTab, onSelectGroup, onSelectVerification }) => (
  <div className="space-y-6">
    {/* Enhanced Statistics Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <StatCard
        title="Total Groups"
        value={dashboardData.total_groups || 0}
        icon={Users}
        color="blue"
        onClick={() => onNavigateToTab('groups')}
      />
      <StatCard
        title="Verified Groups"
        value={dashboardData.verified_groups || 0}
        icon={Check}
        color="green"
        subtitle={`${((dashboardData.verified_groups || 0) / (dashboardData.total_groups || 1) * 100).toFixed(1)}% of total`}
      />
      <StatCard
        title="Pending Verifications"
        value={dashboardData.pending_verifications || 0}
        icon={Clock}
        color="yellow"
        onClick={() => onNavigateToTab('verifications')}
        urgent={dashboardData.pending_verifications > 5}
      />
      <StatCard
        title="Active Groups"
        value={dashboardData.active_groups || 0}
        icon={TrendingUp}
        color="emerald"
      />
    </div>

    {/* Quick Actions */}
    <div className="bg-white rounded-lg border border-gray-100 shadow-sm p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <button
          onClick={() => onNavigateToTab('verifications')}
          className="p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors"
        >
          <Shield className="h-8 w-8 text-blue-600 mx-auto mb-2" />
          <p className="text-sm font-medium text-gray-900">Review Verifications</p>
          <p className="text-xs text-gray-500">
            {dashboardData.pending_verifications || 0} pending
          </p>
        </button>
        <button
          onClick={() => onNavigateToTab('accounts')}
          className="p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-green-500 hover:bg-green-50 transition-colors"
        >
          <DollarSign className="h-8 w-8 text-green-600 mx-auto mb-2" />
          <p className="text-sm font-medium text-gray-900">Manage Accounts</p>
          <p className="text-xs text-gray-500">Transaction accounts</p>
        </button>
        <button
          onClick={() => onNavigateToTab('groups')}
          className="p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-purple-500 hover:bg-purple-50 transition-colors"
        >
          <Users className="h-8 w-8 text-purple-600 mx-auto mb-2" />
          <p className="text-sm font-medium text-gray-900">Manage Groups</p>
          <p className="text-xs text-gray-500">
            {dashboardData.total_groups || 0} total groups
          </p>
        </button>
      </div>
    </div>

    {/* Recent Activity & Charts */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Recent Verification Requests */}
      <div className="bg-white rounded-lg border border-gray-100 shadow-sm">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">Recent Verification Requests</h3>
          <button
            onClick={() => onNavigateToTab('verifications')}
            className="text-blue-600 hover:text-blue-800 text-sm font-medium"
          >
            View All
          </button>
        </div>
        <div className="divide-y divide-gray-100 max-h-96 overflow-y-auto">
          {dashboardData.recent_verification_requests?.length > 0 ? (
            dashboardData.recent_verification_requests.slice(0, 5).map((request) => (
              <div 
                key={request.id} 
                className="px-6 py-4 hover:bg-gray-50 cursor-pointer"
                onClick={() => onSelectVerification(request)}
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h4 className="font-medium text-gray-900">{request.group_name}</h4>
                    <p className="text-sm text-gray-600">
                      Requested by: {request.requested_by_name} • 
                      SEB: {formatCurrency(request.proposed_seb_amount)} • 
                      PEI: {formatCurrency(request.proposed_pei_amount)}
                    </p>
                    <p className="text-xs text-gray-500">
                      {request.days_pending} days ago
                    </p>
                  </div>
                  <div className="flex items-center gap-3">
                    {getStatusBadge(request.status)}
                    <ChevronRight className="h-4 w-4 text-gray-400" />
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="px-6 py-8 text-center text-gray-500">
              No recent verification requests
            </div>
          )}
        </div>
      </div>

      {/* System Overview Chart */}
      <div className="bg-white rounded-lg border border-gray-100 shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">System Overview</h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">Groups Verified</span>
            <span className="text-sm font-medium">
              {((dashboardData.verified_groups || 0) / (dashboardData.total_groups || 1) * 100).toFixed(1)}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div 
              className="bg-green-600 h-2 rounded-full" 
              style={{ 
                width: `${(dashboardData.verified_groups || 0) / (dashboardData.total_groups || 1) * 100}%` 
              }}
            ></div>
          </div>
          
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">Active vs Total</span>
            <span className="text-sm font-medium">
              {((dashboardData.active_groups || 0) / (dashboardData.total_groups || 1) * 100).toFixed(1)}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div 
              className="bg-blue-600 h-2 rounded-full" 
              style={{ 
                width: `${(dashboardData.active_groups || 0) / (dashboardData.total_groups || 1) * 100}%` 
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>

    {/* Groups Needing Attention */}
    {dashboardData.groups_needing_attention?.length > 0 && (
      <div className="bg-white rounded-lg border border-gray-100 shadow-sm">
        <div className="px-6 py-4 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-yellow-500" />
            Groups Needing Attention
          </h3>
        </div>
        <div className="divide-y divide-gray-100">
          {dashboardData.groups_needing_attention.map((item, index) => (
            <div key={index} className="px-6 py-4 hover:bg-gray-50">
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="font-medium text-gray-900">{item.group_name}</h4>
                  <p className="text-sm text-red-600">{item.issue}</p>
                  {item.days_pending && (
                    <p className="text-xs text-gray-500">{item.days_pending} days pending</p>
                  )}
                </div>
                <button
                  onClick={() => onSelectGroup({ id: item.group_id })}
                  className="text-blue-600 hover:text-blue-800"
                >
                  <Eye className="h-4 w-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);

// Enhanced Stat Card Component
const StatCard = ({ title, value, icon: Icon, color, subtitle, onClick, urgent }) => (
  <div 
    className={`bg-white rounded-lg p-6 border border-gray-100 shadow-sm ${
      onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''
    } ${urgent ? 'ring-2 ring-red-200' : ''}`}
    onClick={onClick}
  >
    <div className="flex items-center justify-between">
      <div>
        <p className="text-gray-600 text-sm font-medium">{title}</p>
        <p className="text-2xl font-bold text-gray-900">{value.toLocaleString()}</p>
        {subtitle && <p className="text-xs text-gray-500 mt-1">{subtitle}</p>}
      </div>
      <div className={`p-3 rounded-lg bg-${color}-50`}>
        <Icon className={`h-6 w-6 text-${color}-600`} />
      </div>
    </div>
  </div>
);

// Enhanced Data Table Component
const EnhancedDataTab = ({ 
  title, 
  data, 
  columns, 
  loading, 
  selectedItems, 
  onSelectAll, 
  onSelectItem, 
  onSort, 
  sortConfig,
  searchTerm,
  onSearchChange,
  filters = [],
  actions = [],
  bulkActions = [],
  createAction,
  onExport,
  formatters = {},
  verificationFilter = 'all'
}) => (
  <div className="space-y-6">
    {/* Enhanced Header */}
    <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
      <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
          <p className="text-sm text-gray-600 mt-1">
            {data.length} {data.length === 1 ? 'item' : 'items'}
            {selectedItems.size > 0 && ` • ${selectedItems.size} selected`}
          </p>
        </div>
        
        <div className="flex flex-wrap gap-3">
          {/* Search */}
          {onSearchChange && (
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search..."
                className="pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-64"
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </div>
          )}
          
          {/* Filters */}
          {filters.map((filter, index) => (
            <select
              key={index}
              className="px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={filter.value}
              onChange={(e) => filter.onChange(e.target.value)}
            >
              {filter.options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          ))}
          
          {/* Create Action */}
          {createAction && (
            <button
              onClick={createAction.onClick}
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
            >
              <createAction.icon className="h-4 w-4" />
              {createAction.label}
            </button>
          )}
          
          {/* Export */}
          {onExport && (
            <button
              onClick={onExport}
              className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors"
            >
              <Download className="h-4 w-4" />
              Export
            </button>
          )}
        </div>
      </div>
      
      {/* Bulk Actions */}
      {selectedItems.size > 0 && bulkActions.length > 0 && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-600">
              {selectedItems.size} item(s) selected:
            </span>
            {bulkActions.map((action, index) => (
              <button
                key={index}
                onClick={action.onClick}
                className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition-colors ${
                  action.variant === 'danger'
                    ? 'bg-red-100 text-red-700 hover:bg-red-200'
                    : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                }`}
              >
                <action.icon className="h-3 w-3" />
                {action.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>

    {/* Enhanced Table */}
    <div className="bg-white rounded-lg border border-gray-100 shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              {(bulkActions.length > 0 || selectedItems.size > 0) && (
                <th className="w-12 px-6 py-4">
                  <input
                    type="checkbox"
                    checked={data.length > 0 && selectedItems.size === data.length}
                    onChange={() => onSelectAll(data)}
                    className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                </th>
              )}
              {columns.map((column) => (
                <th
                  key={column.key}
                  className={`px-6 py-4 font-medium text-gray-700 ${
                    column.align === 'center' ? 'text-center' : 
                    column.align === 'right' ? 'text-right' : 'text-left'
                  }`}
                >
                  {column.sortable ? (
                    <button
                      onClick={() => onSort(column.key)}
                      className="flex items-center gap-1 hover:text-gray-900"
                    >
                      {column.label}
                      <ArrowUpDown className="h-3 w-3" />
                      {sortConfig.key === column.key && (
                        sortConfig.direction === 'asc' ? 
                        <ChevronUp className="h-3 w-3" /> : 
                        <ChevronDown className="h-3 w-3" />
                      )}
                    </button>
                  ) : (
                    column.label
                  )}
                </th>
              ))}
              {actions.length > 0 && (
                <th className="text-center px-6 py-4 font-medium text-gray-700">Actions</th>
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {data.map((item, index) => (
              <tr key={item.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                {(bulkActions.length > 0 || selectedItems.size > 0) && (
                  <td className="px-6 py-4">
                    <input
                      type="checkbox"
                      checked={selectedItems.has(item.id)}
                      onChange={() => onSelectItem(item.id)}
                      className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                  </td>
                )}
                {columns.map((column) => (
                  <td
                    key={column.key}
                    className={`px-6 py-4 ${
                      column.align === 'center' ? 'text-center' : 
                      column.align === 'right' ? 'text-right' : 'text-left'
                    }`}
                  >
                    <CellRenderer 
                      value={item[column.key]} 
                      type={column.type} 
                      formatters={formatters}
                      item={item}
                    />
                  </td>
                ))}
                {actions.length > 0 && (
                  <td className="px-6 py-4 text-center">
                    <div className="flex items-center justify-center gap-2">
                      {actions.map((action, actionIndex) => (
                        <button
                          key={actionIndex}
                          onClick={() => action.onClick(item)}
                          className={`p-1 rounded hover:bg-gray-100 ${
                            action.variant === 'danger' ? 'text-red-600 hover:text-red-800' :
                            action.variant === 'primary' ? 'text-blue-600 hover:text-blue-800' :
                            'text-gray-600 hover:text-gray-800'
                          }`}
                          title={action.label}
                        >
                          <action.icon className="h-4 w-4" />
                        </button>
                      ))}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {data.length === 0 && !loading && (
        <div className="text-center py-12">
          <p className="text-gray-500">{`No ${verificationFilter} data found`}</p>
        </div>
      )}
      
      {loading && (
        <div className="text-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-500">Loading...</p>
        </div>
      )}
    </div>
  </div>
);

// Cell Renderer Component
const CellRenderer = ({ value, type, formatters, item }) => {
  switch (type) {
    case 'currency':
      return formatters.currency ? formatters.currency(value) : value;
    case 'status':
      return formatters.status ? formatters.status(value) : value;
    case 'date':
      return formatters.date ? formatters.date(value) : value;
    case 'special':
      return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
          value 
            ? 'bg-purple-100 text-purple-800 border border-purple-200' 
            : 'bg-blue-100 text-blue-800 border border-blue-200'
        }`}>
          {value ? 'Special' : 'Regular'}
        </span>
      );
    case 'active':
      return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
          value 
            ? 'bg-green-100 text-green-800 border border-green-200' 
            : 'bg-red-100 text-red-800 border border-red-200'
        }`}>
          {value ? 'Active' : 'Inactive'}
        </span>
      );
    default:
      return value || '-';
  }
};

// Enhanced Pagination Component
const EnhancedPagination = ({ currentPage, totalPages, pageSize, onPageChange, onPageSizeChange, loading }) => {
  if (totalPages <= 1) return null;

  return (
    <div className="bg-white rounded-lg border border-gray-100 shadow-sm p-4">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-700">Show</span>
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className="border border-gray-300 rounded px-2 py-1 text-sm"
            disabled={loading}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <span className="text-sm text-gray-700">per page</span>
        </div>
        
        <div className="flex items-center gap-2">
          <button
            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1 || loading}
            className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Previous
          </button>
          
          <span className="px-3 py-2 text-sm font-medium text-gray-700">
            Page {currentPage} of {totalPages}
          </span>
          
          <button
            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages || loading}
            className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

// Modals Container Component
const ModalsContainer = ({ 
  selectedVerification, onCloseVerification, onVerificationAction,
  selectedGroup, onCloseGroup,
  selectedAccount, showAccountForm, onCloseAccountForm, onSaveAccount,
  showDeleteGroupModal, onCloseDeleteGroup, onConfirmDeleteGroup,
  formatCurrency, getStatusBadge ,
  selectedDaraja,    
  showDarajaForm,    
  onCloseDarajaForm, 
  onSaveDaraja,      
}) => (
  <>
    {/* Verification Approval Modal */}
    {selectedVerification && (
      <VerificationApprovalModal
        verification={selectedVerification}
        onClose={onCloseVerification}
        onApprove={(amounts) => onVerificationAction(selectedVerification.id, 'approve', amounts)}
        formatCurrency={formatCurrency}
      />
    )}
    {/* Daraja Form Modal */}
      {showDarajaForm && (
  <DarajaFormModal
    daraja={selectedDaraja}
    onClose={onCloseDarajaForm}  
    onSave={onSaveDaraja}
  />
)}

    {/* Group Details Modal */}
    {selectedGroup && (
      <GroupDetailsModal
        group={selectedGroup}
        onClose={onCloseGroup}
        formatCurrency={formatCurrency}
        getStatusBadge={getStatusBadge}
      />
    )}

    {/* Transaction Account Form Modal */}
    {showAccountForm && (
      <TransactionAccountFormModal
        account={selectedAccount}
        onClose={onCloseAccountForm}
        onSave={onSaveAccount}
      />
    )}

    {/* Delete Group Modal */}
    {showDeleteGroupModal && (
      <DeleteGroupModal
        group={showDeleteGroupModal}
        onClose={onCloseDeleteGroup}
        onConfirm={onConfirmDeleteGroup}
      />
    )}
    
  </>
);

// Enhanced Transaction Account Form Modal
const TransactionAccountFormModal = ({ account, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: account?.name || '',
    account_number: account?.account_number || '',
    account_type: account?.account_type || 'entertainment',
    is_special: account?.is_special || false,
    description: account?.description || '',
    min_daraja_level: account?.min_daraja_level || '',
    min_balance: account?.min_balance || '0.00',
    max_balance: account?.max_balance || ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const accountTypes = [
    { value: 'entertainment', label: 'Entertainment' },
    { value: 'hero', label: 'Hero' },
    { value: 'ricg_services', label: 'RicG Services' },
    { value: 'undugu', label: 'Undugu' },
    { value: 'ujasiri', label: 'Jasiri' },
    { value: 'elder_net_friends', label: 'Elder Net-friends' },
    { value: 'escrow_acc_01', label: 'Escrow Acc-01' },
    { value: 'ricg_service_02', label: 'RicG Service-02' },
    { value: 'heros_special', label: 'Heros Special' },
    { value: 'royal_family', label: 'Royal Family' },
    { value: 'enf_fundraise', label: 'ENF Fundraise' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setIsSubmitting(true);

    // Enhanced validation
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Account name is required';
    if (!formData.account_number.trim()) newErrors.account_number = 'Account number is required';
    if (formData.min_balance && formData.max_balance && 
        parseFloat(formData.min_balance) > parseFloat(formData.max_balance)) {
      newErrors.max_balance = 'Maximum balance must be greater than minimum balance';
    }
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitting(false);
      return;
    }

    try {
      await onSave(formData);
    } catch (error) {
      setErrors({ submit: 'Failed to save account. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-900">
              {account ? 'Edit Transaction Account' : 'Create Transaction Account'}
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <X className="h-6 w-6" />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {errors.submit && (
            <div className="bg-red-50 border border-red-200 rounded-md p-3">
              <p className="text-red-600 text-sm">{errors.submit}</p>
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Account Name *
              </label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => handleChange('name', e.target.value)}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  errors.name ? 'border-red-300' : 'border-gray-300'
                }`}
                placeholder="Enter account name"
                disabled={isSubmitting}
              />
              {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Account Number *
              </label>
              <input
                type="text"
                value={formData.account_number}
                onChange={(e) => handleChange('account_number', e.target.value)}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  errors.account_number ? 'border-red-300' : 'border-gray-300'
                }`}
                placeholder="Enter account number"
                disabled={isSubmitting}
              />
              {errors.account_number && <p className="text-red-500 text-xs mt-1">{errors.account_number}</p>}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Account Type
              </label>
              <select
                value={formData.account_type}
                onChange={(e) => handleChange('account_type', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                disabled={isSubmitting}
              >
                {accountTypes.map(type => (
                  <option key={type.value} value={type.value}>{type.label}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Minimum Balance
              </label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={formData.min_balance}
                onChange={(e) => handleChange('min_balance', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="0.00"
                disabled={isSubmitting}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Maximum Balance (Optional)
              </label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={formData.max_balance}
                onChange={(e) => handleChange('max_balance', e.target.value)}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  errors.max_balance ? 'border-red-300' : 'border-gray-300'
                }`}
                placeholder="Leave empty for no limit"
                disabled={isSubmitting}
              />
              {errors.max_balance && <p className="text-red-500 text-xs mt-1">{errors.max_balance}</p>}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Minimum Daraja Level (Optional)
              </label>
              <input
                type="text"
                value={formData.min_daraja_level}
                onChange={(e) => handleChange('min_daraja_level', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="e.g., MSINGI"
                disabled={isSubmitting}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Description
            </label>
            <textarea
              value={formData.description}
              onChange={(e) => handleChange('description', e.target.value)}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Account description..."
              disabled={isSubmitting}
            />
          </div>

          <div>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={formData.is_special}
                onChange={(e) => handleChange('is_special', e.target.checked)}
                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                disabled={isSubmitting}
              />
              <span className="text-sm font-medium text-gray-700">
                Special Account (for advanced daraja levels)
              </span>
            </label>
            <p className="text-xs text-gray-500 mt-1">
              Special accounts can only be used by advanced daraja levels (above basic levels)
            </p>
          </div>

          <div className="flex items-center justify-end gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isSubmitting ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  Saving...
                </>
              ) : (
                account ? 'Update Account' : 'Create Account'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Enhanced Delete Group Modal
const DeleteGroupModal = ({ group, onClose, onConfirm }) => {
  const [confirmText, setConfirmText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    if (confirmText !== group.name) {
      return;
    }

    setIsDeleting(true);
    try {
      await onConfirm();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-red-900">Delete Group</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <X className="h-6 w-6" />
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="flex items-start gap-3 mb-4">
            <AlertTriangle className="h-6 w-6 text-red-500 mt-0.5 flex-shrink-0" />
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Are you absolutely sure?
              </h3>
              <p className="text-sm text-gray-600 mb-3">
                This action cannot be undone. This will permanently delete the group{' '}
                <strong>"{group.name}"</strong> and remove all associated data including:
              </p>
              <ul className="text-sm text-gray-600 list-disc list-inside space-y-1 mb-4">
                <li>All group memberships</li>
                <li>All contribution records</li>
                <li>All cycle history</li>
                <li>All notifications</li>
                <li>All member accounts and transactions</li>
              </ul>
            </div>
          </div>

          <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-4">
            <p className="text-sm text-red-800 mb-2">
              Please type <strong>{group.name}</strong> to confirm deletion:
            </p>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="w-full px-3 py-2 border border-red-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
              placeholder={group.name}
              disabled={isDeleting}
            />
          </div>

          <div className="flex items-center justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
              disabled={isDeleting}
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              disabled={confirmText !== group.name || isDeleting}
              className="px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isDeleting ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  Deleting...
                </>
              ) : (
                'Delete Group'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const useVerificationAmounts = (verification) => {
  const [amounts, setAmounts] = useState({
    base: verification.proposed_base_amount || 0,
    seb: verification.proposed_seb_amount || 0,
    pei: verification.proposed_pei_amount || 0,
    marundo: verification.proposed_marundo_amount || 0,
    ka: verification.group_ka_amount || 0
  });

  // Simplified validation rules - only basic checks
  const validationRules = useMemo(() => ({
    seb: {
      validate: (value) => value > 0
    },
    pei: {
      validate: (value) => value > 0
    },
    marundo: {
      validate: (value) => value >= 0
    }
  }), []);

  // Enhanced calculations
  const calculations = useMemo(() => {
    const suggestedMarundo = Math.round((amounts.seb + amounts.pei) * 0.05);
    const totalPerMemberPerCycle = amounts.pei + amounts.ka + amounts.marundo;
    const beneficiarySebTotal = amounts.seb * (verification.group_member_count - 1);
    const totalPoolPerCycle = totalPerMemberPerCycle * verification.group_member_count;
    const memberCount = verification.group_member_count || 0;
const nonBeneficiaryCount = Math.max(0, memberCount - 1);
    const marundoPercentage = amounts.seb + amounts.pei > 0 ? 
      (amounts.marundo / (amounts.seb + amounts.pei)) * 100 : 0;
// NEW: Base amount calculations
const totalBasePool = amounts.base * memberCount;
const basePercentageOfCycle = totalPerMemberPerCycle > 0 ?
  (amounts.base / totalPerMemberPerCycle) * 100 : 0;
    return {
      suggestedMarundo,
      totalPerMemberPerCycle,
      beneficiarySebTotal,
      totalPoolPerCycle,
      marundoPercentage,
       totalBasePool, 
  basePercentageOfCycle 
    };
  }, [amounts, verification.group_member_count]);

  // Simplified validation function
  const validateAmounts = useCallback(() => {
    const errors = {};

    // Basic validation - only check for positive amounts
    if (!amounts.seb || amounts.seb <= 0) {
      errors.seb = 'SEB amount must be greater than 0';
    }
    
    if (!amounts.pei || amounts.pei <= 0) {
      errors.pei = 'PEI amount must be greater than 0';
    }
    
    if (amounts.marundo < 0) {
      errors.marundo = 'Marundo amount cannot be negative';
    }

// Validate all amounts including base
Object.keys(validationRules).forEach(field => {
  const rule = validationRules[field];
  if (!rule.validate(amounts[field])) {
    errors[field] = rule.message;
  }
});

// Additional business logic validation
if (amounts.base > 0 && amounts.pei > 0) {
  // Base amount should typically be higher than PEI
  // if (amounts.base < amounts.pei) {
  //   errors.base = 'Base amount is typically higher than PEI amount';
  // }
}
    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }, [amounts]);

  const updateAmount = useCallback((field, value) => {
    setAmounts(prev => ({
      ...prev,
      [field]: Number(value) || 0
    }));
  }, []);

  const applySuggestedMarundo = useCallback(() => {
    updateAmount('marundo', calculations.suggestedMarundo);
  }, [calculations.suggestedMarundo, updateAmount]);

  return {
    amounts,
    calculations,
    validationRules,
    validateAmounts,
    updateAmount,
    applySuggestedMarundo
  };
};

// Enhanced verification approval modal with better UX
const VerificationApprovalModal = ({ verification, onClose, onApprove, formatCurrency }) => {
  const {
    amounts,
    calculations,
    validateAmounts,
    updateAmount,
    applySuggestedMarundo
  } = useVerificationAmounts(verification);

  const [adminNotes, setAdminNotes] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);

  const { isValid, errors } = validateAmounts();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isValid) return;
    
    setIsSubmitting(true);
    
    try {
      await onApprove({
        final_base_amount: amounts.base, 
        final_seb_amount: amounts.seb,
        final_pei_amount: amounts.pei,
        final_marundo_amount: amounts.marundo,
        admin_notes: adminNotes
      });
    } catch (error) {
      console.error('Approval failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-5xl w-full max-h-[90vh] overflow-y-auto">
        {/* Modal header */}
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-semibold text-gray-900">
                Approve Verification: {verification.group_name}
              </h2>
              <p className="text-sm text-gray-600 mt-1">
                {verification.group_daraja} • {verification.group_member_count} members
              </p>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <X className="h-6 w-6" />
            </button>
          </div>
        </div>

        <div className="p-6">
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* NEW: Reference Information - Shows proposed/current amounts */}
        <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
          <h3 className="font-medium text-blue-900 mb-3 flex items-center gap-2">
            <AlertTriangle className="h-5 w-5" />
            Reference Information
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-sm">
            <div>
              <div className="text-blue-700 font-medium">Daraja Base Amount</div>
              <div className="text-blue-900 font-semibold">
                {formatCurrency(verification.daraja_reference_base_amount || 0)}
              </div>
              <div className="text-xs text-blue-600">From daraja level</div>
            </div>
            <div>
              <div className="text-blue-700 font-medium">Previous Group Base</div>
              <div className="text-blue-900 font-semibold">
                {formatCurrency(verification.final_base_amount || 0)}
              </div>
              <div className="text-xs text-blue-600">
                {verification.is_subsequent_lap ? 'Current amount' : 'Proposed'}
              </div>
            </div>
            <div>
              <div className="text-blue-700 font-medium">Previous SEB</div>
              <div className="text-blue-900 font-semibold">
                {formatCurrency(verification.proposed_seb_amount || 0)}
              </div>
            </div>
            <div>
              <div className="text-blue-700 font-medium">Previous PEI</div>
              <div className="text-blue-900 font-semibold">
                {formatCurrency(verification.proposed_pei_amount || 0)}
              </div>
            </div>
            <div>
              <div className="text-blue-700 font-medium">Group KA</div>
              <div className="text-blue-900 font-semibold">
                {formatCurrency(amounts.ka)}
              </div>
              <div className="text-xs text-blue-600">Fixed per member</div>
            </div>
          </div>
        </div>

        {/* NEW: Amount Input Section with Base Amount */}
        <div className="bg-white border border-gray-200 rounded-lg p-4">
          <h3 className="font-medium text-gray-900 mb-4">Set Approved Amounts</h3>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
            {/* NEW: Base Amount Input */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Base Amount (TZS) *
                <span className="text-xs text-gray-500 block mt-1">
                  Members pay once before cycles
                </span>
              </label>
              <input
                type="number"
                value={amounts.base}
                onChange={(e) => updateAmount('base', e.target.value)}
                className={`w-full px-3 py-2 border rounded-md ${
                  errors.base ? 'border-red-300' : 'border-gray-300'
                }`}
                
                disabled={isSubmitting}
              />
              {errors.base && <p className="text-red-500 text-xs mt-1">{errors.base}</p>}
              <div className="mt-1 text-xs text-gray-500">
                Suggested: {formatCurrency(verification.daraja_reference_base_amount || 0)}
              </div>
            </div>

            {/* SEB Amount Input */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                SEB Amount (TZS) *
                <span className="text-xs text-gray-500 block mt-1">
                  Beneficiary pays per cycle
                </span>
              </label>
              <input
                type="number"
                value={amounts.seb}
                onChange={(e) => updateAmount('seb', e.target.value)}
                className={`w-full px-3 py-2 border rounded-md ${
                  errors.seb ? 'border-red-300' : 'border-gray-300'
                }`}
                
                disabled={isSubmitting}
              />
              {errors.seb && <p className="text-red-500 text-xs mt-1">{errors.seb}</p>}
            </div>

            {/* PEI Amount Input */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                PEI Amount (TZS) *
                <span className="text-xs text-gray-500 block mt-1">
                  Members pay per cycle
                </span>
              </label>
              <input
                type="number"
                value={amounts.pei}
                onChange={(e) => updateAmount('pei', e.target.value)}
                className={`w-full px-3 py-2 border rounded-md ${
                  errors.pei ? 'border-red-300' : 'border-gray-300'
                }`}
               
                disabled={isSubmitting}
              />
              {errors.pei && <p className="text-red-500 text-xs mt-1">{errors.pei}</p>}
            </div>

            {/* Marundo Amount Input */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Marundo Amount (TZS) *
                <span className="text-xs text-gray-500 block mt-1">
                  Final payment per cycle
                </span>
              </label>
              <input
                type="number"
                value={amounts.marundo}
                onChange={(e) => updateAmount('marundo', e.target.value)}
                className={`w-full px-3 py-2 border rounded-md ${
                  errors.marundo ? 'border-red-300' : 'border-gray-300'
                }`}
               
                disabled={isSubmitting}
              />
              {calculations.suggestedMarundo !== amounts.marundo && (
                <button
                  type="button"
                  onClick={applySuggestedMarundo}
                  className="text-xs text-blue-600 hover:text-blue-800 mt-1"
                >
                  Use suggested: {formatCurrency(calculations.suggestedMarundo)}
                </button>
              )}
              {errors.marundo && <p className="text-red-500 text-xs mt-1">{errors.marundo}</p>}
            </div>
          </div>

          {/* KA Amount Display (Read-only) */}
          <div className="bg-gray-50 p-3 rounded-md border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <span className="text-sm font-medium text-gray-700">KA Amount (Fixed)</span>
                <span className="text-xs text-gray-500 block">Members pay per cycle to pool</span>
              </div>
              <span className="text-lg font-bold text-gray-900">
                {formatCurrency(amounts.ka)}
              </span>
            </div>
          </div>
        </div>

        {/* Calculation Summary */}
        <div className="bg-green-50 border border-green-200 rounded-lg p-4">
          <h4 className="font-medium text-green-800 mb-3">Approval Summary</h4>
          <div className="grid grid-cols-2 gap-4 text-sm">
            {/* NEW: Base Amount Info */}
            <div className="col-span-2 bg-white p-3 rounded border border-green-200">
              <div className="flex items-center justify-between mb-2">
                <span className="text-green-700 font-medium">One-Time Base Payment (Before Cycles)</span>
                <span className="font-bold text-green-900 text-lg">
                  {formatCurrency(amounts.base)}
                </span>
              </div>
              <div className="text-xs text-green-600">
                Each member pays this amount once to individual accounts before cycles can start
              </div>
              <div className="mt-2 pt-2 border-t border-green-200">
                <div className="flex justify-between text-xs">
                  <span>Total Group Base Pool:</span>
                  <span className="font-semibold">
                    {formatCurrency(amounts.base * (verification.group_member_count || 0))}
                  </span>
                </div>
              </div>
            </div>

            {/* Per Cycle Payments */}
            <div className="col-span-2">
              <h5 className="font-medium text-green-800 mb-2">Per Cycle Payments</h5>
              <div className="space-y-2">
                <div className="flex justify-between bg-white p-2 rounded">
                  <span className="text-green-700">Per Member per Cycle (PEI + KA + Marundo):</span>
                  <span className="font-semibold text-green-900">
                    {formatCurrency(calculations.totalPerMemberPerCycle)}
                  </span>
                </div>
                <div className="flex justify-between bg-white p-2 rounded">
                  <span className="text-green-700">Beneficiary SEB Total (to others):</span>
                  <span className="font-semibold text-green-900">
                    {formatCurrency(calculations.beneficiarySebTotal)}
                  </span>
                </div>
                <div className="flex justify-between bg-white p-2 rounded">
                  <span className="text-green-700">Total Pool per Cycle:</span>
                  <span className="font-semibold text-green-900">
                    {formatCurrency(calculations.totalPoolPerCycle)}
                  </span>
                </div>
                <div className="flex justify-between bg-white p-2 rounded">
                  <span className="text-green-700">Marundo %:</span>
                  <span className="font-semibold text-green-900">
                    {calculations.marundoPercentage.toFixed(1)}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Admin notes */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Admin Notes
          </label>
          <textarea
            value={adminNotes}
            onChange={(e) => setAdminNotes(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            rows={3}
            placeholder="Add notes for the chairperson about the approved amounts..."
          />
        </div>

        {/* Action buttons */}
        <div className="flex justify-end gap-3 pt-4 border-t">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={!isValid || isSubmitting}
            className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md disabled:opacity-50 flex items-center gap-2"
          >
            {isSubmitting ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                Approving...
              </>
            ) : (
              <>
                <Check className="h-4 w-4" />
                Approve Verification
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
  );
};

const GroupDetailsModal = ({ group, onClose, formatCurrency, getStatusBadge }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-900">{group.name}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <X className="h-6 w-6" />
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div>
              <p className="text-sm font-medium text-gray-700">Status</p>
              <div className="mt-1">{getStatusBadge(group.status)}</div>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-700">Daraja Level</p>
              <p className="text-sm text-gray-600">{group.contribution_level}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-700">Members</p>
              <p className="text-sm text-gray-600">{group.member_count || 0}</p>
            </div>
          </div>

          {group.is_verified && (
            <div className="bg-green-50 p-4 rounded-lg mb-6">
              <h3 className="text-lg font-medium text-green-800 mb-2">Verification Details</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm font-medium text-green-700">SEB Amount</p>
                  <p className="text-lg font-semibold text-green-900">
                    {formatCurrency(group.seb_amount)}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-green-700">PEI Amount</p>
                  <p className="text-lg font-semibold text-green-900">
                    {formatCurrency(group.pei_amount)}
                  </p>
                </div>
              </div>
              <div className="mt-3">
                <p className="text-sm text-green-700">
                  Verified on: {KileleniService.formatDate(group.verified_at)} by {group.verified_by_name}
                </p>
                {group.verification_notes && (
                  <p className="text-sm text-green-600 mt-1">{group.verification_notes}</p>
                )}
              </div>
            </div>
          )}

          <div className="bg-white border border-gray-200 rounded-lg">
            <div className="px-4 py-3 border-b border-gray-200">
              <h3 className="text-lg font-medium text-gray-900">Group Members</h3>
            </div>
            <div className="divide-y divide-gray-200 max-h-64 overflow-y-auto">
              {group.members?.map((member) => (
                <div key={member.id} className="px-4 py-3">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                        <User className="h-4 w-4 text-gray-600" />
                      </div>
                      <div>
                        <p className="font-medium text-gray-900">{member.user?.name || 'Unknown'}</p>
                        <p className="text-sm text-gray-600">{member.user?.email || 'No email'}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="mb-1">{getStatusBadge(member.role)}</div>
                      <p className="text-xs text-gray-500">
                        Position: {member.position_in_cycle || 'N/A'}
                      </p>
                      <p className="text-xs text-gray-500">
                        Joined: {KileleniService.formatDate(member.joined_at)}
                      </p>
                    </div>
                  </div>
                </div>
              )) || (
                <div className="px-4 py-8 text-center text-gray-500">
                  No members data available
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-md transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
// Daraja Form Modal Component
const DarajaFormModal = ({ daraja, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: daraja?.name || '',
    description: daraja?.description || '',
    min_amount: daraja?.min_amount || '',
    max_amount: daraja?.max_amount || '',
    total_base_amount: daraja?.total_base_amount || '',
    enf_amount: daraja?.enf_amount || '',
    escrow_amount: daraja?.escrow_amount || '',
    fundraise_amount: daraja?.fundraise_amount || '',
    undugu_amount: daraja?.undugu_amount || '',
    jasiri_amount: daraja?.jasiri_amount || '',
    hero_amount: daraja?.hero_amount || '',
    royal_f_amount: daraja?.royal_f_amount || '',
    ma_amount: daraja?.ma_amount || '',
    is_active: daraja?.is_active !== undefined ? daraja.is_active : true
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [calculatedTotal, setCalculatedTotal] = useState(0);
  const [showMismatchWarning, setShowMismatchWarning] = useState(false);

  // Calculate total allocations
  useEffect(() => {
    const total = [
      'enf_amount', 'escrow_amount', 'fundraise_amount',
      'undugu_amount', 'jasiri_amount', 'hero_amount',
      'royal_f_amount', 'ma_amount'
    ].reduce((sum, field) => {
      return sum + (parseFloat(formData[field]) || 0);
    }, 0);
    
    setCalculatedTotal(total);
    
    // Check for mismatch
    const totalBase = parseFloat(formData.total_base_amount) || 0;
    const mismatch = Math.abs(total - totalBase) > 0.01;
    setShowMismatchWarning(mismatch && totalBase > 0);
  }, [formData.enf_amount, formData.escrow_amount, formData.fundraise_amount, formData.undugu_amount, formData.jasiri_amount, formData.hero_amount, formData.royal_f_amount, formData.ma_amount, formData.total_base_amount, formData]);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const validate = () => {
    const newErrors = {};

    // Required fields
    const requiredFields = [
      'name', 'min_amount', 'max_amount', 'total_base_amount',
      'enf_amount', 'escrow_amount', 'fundraise_amount',
      'undugu_amount', 'jasiri_amount', 'hero_amount',
      'royal_f_amount', 'ma_amount'
    ];

    requiredFields.forEach(field => {
      if (!formData[field] || formData[field].toString().trim() === '') {
        newErrors[field] = 'Required';
      }
    });

    // Numeric validation
    const amountFields = requiredFields.filter(f => f !== 'name');
    amountFields.forEach(field => {
      const value = parseFloat(formData[field]);
      if (isNaN(value) || value < 0) {
        newErrors[field] = 'Must be ≥ 0';
      }
    });

    // Min/Max validation
    if (parseFloat(formData.min_amount) > parseFloat(formData.max_amount)) {
      newErrors.min_amount = 'Cannot exceed max';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    // Check if allocations match total
    const totalBase = parseFloat(formData.total_base_amount);
    const allocationsMismatch = Math.abs(calculatedTotal - totalBase) > 0.01;

    // if (allocationsMismatch && totalBase > 0) {
    //   const confirmed = window.confirm(
    //     `Warning: Allocations total (${calculatedTotal.toFixed(2)}) doesn't match ` +
    //     `Total Base Amount (${totalBase.toFixed(2)}). Continue anyway?`
    //   );
    //   if (!confirmed) return;
    // }

    setIsSubmitting(true);

    // Prepare data
    const payload = {
      name: formData.name.trim(),
      description: formData.description.trim(),
      min_amount: parseFloat(formData.min_amount),
      max_amount: parseFloat(formData.max_amount),
      total_base_amount: parseFloat(formData.total_base_amount),
      enf_amount: parseFloat(formData.enf_amount),
      escrow_amount: parseFloat(formData.escrow_amount),
      fundraise_amount: parseFloat(formData.fundraise_amount),
      undugu_amount: parseFloat(formData.undugu_amount),
      jasiri_amount: parseFloat(formData.jasiri_amount),
      hero_amount: parseFloat(formData.hero_amount),
      royal_f_amount: parseFloat(formData.royal_f_amount),
      ma_amount: parseFloat(formData.ma_amount),
      is_active: formData.is_active
    };

    try {
      await onSave(payload);
    } catch (error) {
      setErrors({ submit: 'Failed to save Daraja. Please try again.' });
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="p-6 border-b border-gray-200 sticky top-0 bg-white z-10">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-900">
              {daraja ? 'Edit Daraja Level' : 'Create Daraja Level'}
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <X className="h-6 w-6" />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {errors.submit && (
            <div className="bg-red-50 border border-red-200 rounded-md p-3">
              <p className="text-red-600 text-sm">{errors.submit}</p>
            </div>
          )}

          {/* Mismatch Warning */}
          {showMismatchWarning && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
              <div className="flex items-start gap-2">
                <AlertTriangle className="h-5 w-5 text-yellow-600 mt-0.5 flex-shrink-0" />
                <div>
                  <h4 className="font-medium text-yellow-800">Allocation Mismatch</h4>
                  <p className="text-sm text-yellow-700 mt-1">
                    Allocations total: <strong>{calculatedTotal.toFixed(2)}</strong> • 
                    Total Base Amount: <strong>{parseFloat(formData.total_base_amount || 0).toFixed(2)}</strong>
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Basic Information */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h3 className="font-medium text-blue-900 mb-4">Basic Information</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Daraja Name *
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                    errors.name ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="e.g., AWALI, MSINGI, PAA"
                  disabled={isSubmitting}
                />
                {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description
                </label>
                <textarea
                  value={formData.description}
                  onChange={(e) => handleChange('description', e.target.value)}
                  rows={2}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Description of this daraja level..."
                  disabled={isSubmitting}
                />
              </div>
            </div>
          </div>

          {/* Amount Ranges */}
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h3 className="font-medium text-green-900 mb-4">Amount Ranges</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Minimum Amount (TZS) *
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.min_amount}
                  onChange={(e) => handleChange('min_amount', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 ${
                    errors.min_amount ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                  disabled={isSubmitting}
                />
                {errors.min_amount && <p className="text-red-500 text-xs mt-1">{errors.min_amount}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Maximum Amount (TZS) *
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.max_amount}
                  onChange={(e) => handleChange('max_amount', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 ${
                    errors.max_amount ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                  disabled={isSubmitting}
                />
                {errors.max_amount && <p className="text-red-500 text-xs mt-1">{errors.max_amount}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Total Base Amount (TZS) *
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.total_base_amount}
                  onChange={(e) => handleChange('total_base_amount', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 ${
                    errors.total_base_amount ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                  disabled={isSubmitting}
                />
                {errors.total_base_amount && <p className="text-red-500 text-xs mt-1">{errors.total_base_amount}</p>}
              </div>
            </div>
          </div>

          {/* Account Allocations */}
          <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
            <h3 className="font-medium text-purple-900 mb-4">
              Account Allocations
              <span className="text-sm font-normal text-purple-700 ml-2">
                (Total: {calculatedTotal.toFixed(2)} TZS)
              </span>
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  ENF Amount *
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.enf_amount}
                  onChange={(e) => handleChange('enf_amount', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                    errors.enf_amount ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                  disabled={isSubmitting}
                />
                {errors.enf_amount && <p className="text-red-500 text-xs mt-1">{errors.enf_amount}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Escrow Amount *
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.escrow_amount}
                  onChange={(e) => handleChange('escrow_amount', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                    errors.escrow_amount ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                  disabled={isSubmitting}
                />
                {errors.escrow_amount && <p className="text-red-500 text-xs mt-1">{errors.escrow_amount}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Fundraise Amount *
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.fundraise_amount}
                  onChange={(e) => handleChange('fundraise_amount', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                    errors.fundraise_amount ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                  disabled={isSubmitting}
                />
                {errors.fundraise_amount && <p className="text-red-500 text-xs mt-1">{errors.fundraise_amount}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Undugu Amount *
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.undugu_amount}
                  onChange={(e) => handleChange('undugu_amount', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                    errors.undugu_amount ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                  disabled={isSubmitting}
                />
                {errors.undugu_amount && <p className="text-red-500 text-xs mt-1">{errors.undugu_amount}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Jasiri Amount *
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.jasiri_amount}
                  onChange={(e) => handleChange('jasiri_amount', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                    errors.jasiri_amount ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                  disabled={isSubmitting}
                />
                {errors.jasiri_amount && <p className="text-red-500 text-xs mt-1">{errors.jasiri_amount}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Hero Amount *
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.hero_amount}
                  onChange={(e) => handleChange('hero_amount', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                    errors.hero_amount ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                  disabled={isSubmitting}
                />
                {errors.hero_amount && <p className="text-red-500 text-xs mt-1">{errors.hero_amount}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Royal Family Amount *
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.royal_f_amount}
                  onChange={(e) => handleChange('royal_f_amount', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                    errors.royal_f_amount ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                  disabled={isSubmitting}
                />
                {errors.royal_f_amount && <p className="text-red-500 text-xs mt-1">{errors.royal_f_amount}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  KA Amount *
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.ma_amount}
                  onChange={(e) => handleChange('ma_amount', e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                    errors.ma_amount ? 'border-red-300' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                  disabled={isSubmitting}
                />
                {errors.ma_amount && <p className="text-red-500 text-xs mt-1">{errors.ma_amount}</p>}
              </div>
            </div>
          </div>

          {/* Status */}
          <div>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={formData.is_active}
                onChange={(e) => handleChange('is_active', e.target.checked)}
                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                disabled={isSubmitting}
              />
              <span className="text-sm font-medium text-gray-700">
                Active (Groups can use this daraja level)
              </span>
            </label>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center justify-end gap-3 pt-4 border-t sticky bottom-0 bg-white">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isSubmitting ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  Saving...
                </>
              ) : (
                <>
                  <Check className="h-4 w-4" />
                  {daraja ? 'Update Daraja' : 'Create Daraja'}
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


export default KileleniManagement;